export default {
    _prefix: "qualityFormViewer.footer",
    labels: {
        release: "Release",
        releaseOptions: "Release Options",
        releaseEvaluation: "Release the Evaluation",
        releaseEvaluationNow: "Immediately ",
        releaseEvaluationNever: "Never",
        releaseEvaluationCustom: "Custom",
        releaseEvaluationEOD: "At the end of the day ",
        releaseEvaluationEOW: "At the end of the week ",
        releaseEvaluationExistingTime: "At the existing release time ",
        timezone: "Timezone",
        noReleaseDate: "Evaluation will not be released",
        futureReleaseDate: (data: { releaseDate: string }) =>
            "Evaluation will release on {{releaseDate}}",
        pastReleaseDate: (data: { releaseDate: string }) =>
            "Evaluation was released on {{releaseDate}}",
    },
};
